import { UserModel } from "./User.model";

export class User extends UserModel {
    // Add custom methods here
}
